
import { motion } from 'framer-motion';
import { adoptionSteps } from '../../../mocks/adoptableCats';

export default function AdoptionProcess() {
  return (
    <section className="py-12 sm:py-20 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="font-heading font-bold text-2xl sm:text-4xl lg:text-5xl text-gray-900 mb-3">
            How <span className="text-accent">Adoption</span> Works
          </h2>
          <p className="font-body text-gray-500 text-sm sm:text-base max-w-xl mx-auto">
            From browsing to bringing your new friend home — it&apos;s easier than you think.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8">
          {adoptionSteps.map((step, index) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="relative mx-auto mb-4 sm:mb-6">
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-accent/10 rounded-2xl flex items-center justify-center mx-auto">
                  <i className={`${step.icon} text-2xl sm:text-3xl text-accent`}></i>
                </div>
                <div className="absolute -top-2 -right-2 w-7 h-7 sm:w-8 sm:h-8 bg-accent text-white rounded-full flex items-center justify-center font-heading font-bold text-xs sm:text-sm">
                  {index + 1}
                </div>
              </div>
              <h3 className="font-heading font-bold text-sm sm:text-lg text-gray-900 mb-1 sm:mb-2">{step.title}</h3>
              <p className="font-body text-xs sm:text-sm text-gray-500 leading-relaxed">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
